import { useRequestAds } from '../hooks/useRequestAds'
import AsideAds from './AsideAds'
import FormRequestAds from './FormRequestAds'

const RequestTesterContent = () => {
  const { ads, curlCommand } = useRequestAds()

  return (
    <div className="container w-100">
      <div className="row">
        <FormRequestAds />

        <AsideAds ads={ads} curlCommand={curlCommand} />
      </div>
    </div>
  )
}

export default RequestTesterContent
